import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import bindAllOfThis from 'src/utils/BindThisHelper';
import { Layout } from "antd";
import { MissionState } from "src/redux/CheckpointReducer";
import { UserState } from "src/redux/UserReducer";
import { ReduxStoreModel } from "src/redux/ReduxModel";
import 'src/components/mission/Mission.less';
import GeneralHeader from "src/layouts/GeneralHeader";
import { Checkpoints } from "src/constants/Checkpoints";

const { Content } = Layout;

interface PlanetLayoutProps {
    missionStatus: MissionState;
    userStatus: UserState;
}

interface PlanetLayoutState {
}

class PlanetLayout extends React.Component<PlanetLayoutProps, PlanetLayoutState> {
    constructor(props: PlanetLayoutProps) {
        super(props);
        bindAllOfThis(this, PlanetLayout.prototype);
    }

    public render() {
        let renderLanguageToggle =
            this.props.missionStatus.current.checkpointId !== Checkpoints.Game.id &&
            this.props.missionStatus.current.checkpointId !== Checkpoints.Activity.id;

        return <Layout className="planet-mission" style={{ height: '100vh' }}>
            <GeneralHeader
                renderEmulationBanner={false}
                renderFullscreenToggle={true}
                renderLanguageToggle={renderLanguageToggle}
                renderAudioToggle={true}
                renderPlanetBox={false}
                renderBackToSpaceStation={false}
            />
            <Content>
                {this.props.children}
            </Content>
        </Layout>;
    }
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        missionStatus: state.Mission,
        userStatus: state.User
    };
}

export default connect(mapStateToProps)(PlanetLayout);



// WEBPACK FOOTER //
// ./src/layouts/planet/PlanetLayout.tsx